// extracted by mini-css-extract-plugin
export default {"loadingwrapper":"Implant_loadingwrapper__O5gsd","commentWrapper":"Implant_commentWrapper__nZ3sE"};